const color = {
  primary: '#0594b4',
  secondary: '#22b7d8',
  gray: '#eeeeee',
  lightGray: '#c0c0c0',
  white: '#ffffff'
};

export default color;

